import { Cols, PriceCols } from "../shared/Consts"
import PortUtils from "./PortUtils"
import { Tooltip } from "@mui/material"

export default class TableUtils {
    static align(col:string) : "right"|"left" {
        switch(col){
        case PriceCols.ticker:
        case PriceCols.sector:
        case PriceCols.frequency:
        case Cols.note:
        case Cols.name:
        case Cols.accountId:
        case Cols.type:
        case Cols.id:
        case Cols.date: return "left"
        default:        return "right"
        }
    }    

    static header(col:string) {
        const tooltip = PortUtils.hint(col)
        if (tooltip=="") return PortUtils.label(col)
        else return <Tooltip title={tooltip} key={col}><span>{PortUtils.label(col)}</span></Tooltip>
    }    
}